module.exports = __webpack_public_path__ + "img/zimbabwe.838fb148.svg";